import { ReactNode } from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import EcdAggressionIcon from 'assets/icons/ecd-aggression-icon.svg?react';
import EcdInfectionIcon from 'assets/icons/ecd-infection-icon.svg?react';
import EcdWarningIcon from 'assets/icons/ecd-warning-icon.svg?react';

import ElectronicClientRecordClientAlert from 'features/residents/models/electronic-client-record-alert';
import ElectronicClientRecordClientAlertType from 'features/residents/models/electronic-client-record-alert-type';
import styles from './electronic-client-record-alert-item.module.scss';

type Props = {
  alert: ElectronicClientRecordClientAlert;
};

const ElectronicClientRecordAlertItem = ({ alert }: Props): React.JSX.Element => {
  const getIcon = (alertType: ElectronicClientRecordClientAlertType): ReactNode | null => {
    switch (alertType) {
      case ElectronicClientRecordClientAlertType.Infection:
        return <EcdInfectionIcon />;
      case ElectronicClientRecordClientAlertType.Aggression:
        return <EcdAggressionIcon />;
      case ElectronicClientRecordClientAlertType.Warning:
        return <EcdWarningIcon />;
      default:
        return null;
    }
  };

  return (
    <Alert icon={getIcon(alert.alertType)} className={styles.ecdAlertItem}>
      <Typography className={styles.ecdAlertItemLabel}>{alert.name}</Typography>
    </Alert>
  );
};

export default ElectronicClientRecordAlertItem;
